import { VariantType } from 'notistack';

export const snackbar = (
    enqueueSnackbar: (message: string, options?: any) => void,
    message: string,
    variant: VariantType,
    action?: JSX.Element | null
) => {
    enqueueSnackbar(message, {
        preventDuplicate: true,
        anchorOrigin: {
            horizontal: 'left',
            vertical: 'bottom'
        },
        variant,
        autoHideDuration: 5000,
        action: action || null
    });
};
